// extracted by mini-css-extract-plugin
export default {"msgArea":"UserTable_msgArea__15dV3","buttonViewMoreArea":"UserTable_buttonViewMoreArea__f-lRH","container":"UserTable_container__Zrg9m","btnArea":"UserTable_btnArea__y-7Wy"};